<template>
    <el-dialog title="Suppression des images" v-loading="loader" :visible.sync="display" width="80%">
        <span>Supprime les images des {{ items_selected }} produits selectionnés</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="display = false">Annuler</el-button>
            <el-button v-if='user().can("bulk remove images")' type="primary" @click="action">Enregistrer</el-button>
            <el-button v-else type="primary" title="Vous n'avez pas les droits necessaires" disabled>Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            form: {
                sync: false,
            },
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        },
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            let text = "Etes vous sur de vouloir supprimer définitivement les images des produits selectionnés ?";

            this.$confirm(text, 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'error',
                customClass: 'danger-message',
            })
                .then(() => {
                    var products = this.selected.map(v => v.id);
                    this.loader = true;

                    var datas = {
                        products,
                        sync: this.form.sync,
                        mode: 'remove_images'
                    };
                    datas.total_item = this.total_item
                    datas.items_selected = this.items_selected

                    if (this.applyToAllResult) {
                        datas.filters = this.filters;
                    }

                    console.log(datas);

                    axios
                        .post('/products/bulk', datas)
                        .then(r => {
                            this.$emit('saved', r);
                            this.$refs.form.resetFields();
                            this.display = false;
                        })
                        .catch(() => {})
                        .then(() => {
                            this.loader = false;
                        });
                })
                .catch(()=>{})
        },
        user() {
            return this.$store.getters['app/user'];
        },
    }
};
</script>

<style>
    .danger-message .el-message-box__message p {
        color: red;
    }

    .danger-message .el-button--primary {
        background-color: red;
        border-color: red;
    }
</style>
